import { render, staticRenderFns } from "./RevenueReport.vue?vue&type=template&id=65c290a8&scoped=true&"
import script from "./RevenueReport.vue?vue&type=script&lang=js&"
export * from "./RevenueReport.vue?vue&type=script&lang=js&"
import style0 from "./RevenueReport.vue?vue&type=style&index=0&id=65c290a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c290a8",
  null
  
)

export default component.exports